import { inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from '../../../environments';
import { HttpClient } from '@angular/common/http';

const basePath = `${environment.apiBaseUrl}promo`;

@Injectable({ providedIn: 'root' })
export class PromoCodeApiClient {
    private readonly _http = inject(HttpClient);

    checkIfCodeIsValid(code: string, userId?: string | null): Observable<CheckPromoCodeValidResponse> {
        return userId == null
            ? this._http.get<CheckPromoCodeValidResponse>(`${basePath}/is-valid?code=${code}`)
            : this._http.get<CheckPromoCodeValidResponse>(`${basePath}/is-valid/${userId}?code=${code}`);
    }
}

export interface CheckPromoCodeValidResponse {
    isValid: boolean;
    errorMessage?: string | null;
}
